import { createRoute } from '@tanstack/react-router';
import { PujcovnaPrehledPage } from '@/modules/pujcovna/PujcovnaPrehledPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/prehled',
  component: PujcovnaPrehledPage,
});
